/** New API fields are authoritative; old APIs retain the existing fallback. */
export function trialClaimDepositBlocked(conditions) {
  if (!conditions || conditions.claimed) return false;
  if (typeof conditions.trialClaimEligible === 'boolean') return !conditions.trialClaimEligible;
  return conditions.hasRealDeposit === false;
}

export function trialFirstDepositIneligible(conditions) {
  return trialClaimDepositBlocked(conditions) && conditions.trialFirstDepositCompleted === true;
}
